/* Shared touch-rail controller.
   The rail scrolls natively; this only wires the prev/next buttons and
   disables them at the ends. Re-runs on Shopify section reload. */
(function () {
  function step(rail) {
    var first = rail.firstElementChild;
    if (!first) return rail.clientWidth;
    var cs = getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rk-railroot]').forEach(function (root) {
      if (root.dataset.rkRailReady === '1') return;
      root.dataset.rkRailReady = '1';

      var rail = root.querySelector('[data-rk-rail]');
      if (!rail) return;
      var prev = root.querySelector('[data-rk-prev]');
      var next = root.querySelector('[data-rk-next]');

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        if (max <= 2) {
          var nav = root.querySelector('.rk-railnav');
          if (nav) nav.style.display = 'none';
        }
      }

      if (prev) prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(rail), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        rail.scrollBy({ left: step(rail), behavior: 'smooth' });
      });

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.rkInitRails = init;
})();
